import React from 'react';
import PropTypes from 'prop-types';
import SubCategoryItem from './SubCategoryItem';
import styles from './SubCategory.module.css';

const SubCategoryList = ({
  subcategories = [],
  selectedSubCategory,
  onSubCategoryChange,
}) => {
  // Fonction qui s'exécute au changement de valeur du dropdown
  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    // On informe le parent de la nouvelle sélection
    onSubCategoryChange(newValue);
  };

  // Vérification si la liste des sous-catégories n'est pas vide
  if (subcategories.length === 0) {
    return null; // Ne rien afficher si aucune sous-catégorie
  }

  return (
    <>
      {/* Liste des sous-catégories */}
        {subcategories.map((subcat) => (
          <SubCategoryItem
            key={subcat.id}
            name={subcat.name}
            slug={subcat.slug}
            banner={subcat.banner}
            pages={subcat.pages}
          />
        ))}
    </>
  );
};

SubCategoryList.propTypes = {
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      banner: PropTypes.shape({
        path: PropTypes.string,
      }),
      pages: PropTypes.array,
    })
  ),
  selectedSubCategory: PropTypes.string,
  onSubCategoryChange: PropTypes.func.isRequired,
};

export default SubCategoryList;